<app-dialog-wrapper
    heading="request.assignDialog.emea.title"
    description="request.assignDialog.emea.description"
    confirmLabel="request.assignDialog.emea.confirm"
    cancelLabel="request.assignDialog.emea.cancel"
    (confirmed)="confirm()"
    (cancelled)="close()"
>
    <sh-user-picker
        label="{{ 'request.assignDialog.emea.assignee' | translate }}"
        [formControl]="selectedUser"
        [roles]="[rolesEnum.TASK_OWNER]"
    ></sh-user-picker>
</app-dialog-wrapper>
